import axios from "axios";
import { SET_ERROR, ALL_COMPANIES } from "../../types"

export const allCompanies = () => {
    return async dispatch => {
        await axios.get('/api/listing/get-all-companies').then(res => {
            dispatch({
                type: ALL_COMPANIES,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}